export const gifts = {
    namespaced: true,
    state: [
        {title: 'test', url: 'http://www.google.com', purchased: false, purchasedBy: null}
    ],
    mutations: {
        add(state, gift) {
            state.push({
                title: gift.title,
                url: gift.url,
                addedBy: gift.addedBy,
                purchased: false,
                purchasedBy: null
            })
        },
        purchase(state, purchase) {
            state.forEach((gift, i) => {
                if(gift.title == purchase.title) {
                    state[i].purchased = true
                    state[i].purchasedBy = purchase.purchasedBy
                }
            })
        }
    }
}